<template>
	<div :class="classes">
		<component v-if="menuItemIcon" :is="menuItemIcon" />
		{{ (menuItemRef.label == null) ? $t('menu.' + menuItemRef.key) : menuItemRef.label }}
	</div>
</template>

<script>
import { computed, toRef } from 'vue';

import { UserOutlined } from '@ant-design/icons-vue';

import Consts from '@/api/Consts';

const ICONS = {
	'account': UserOutlined,
}

export default {
	components: {
		UserOutlined,
	},
	props: ['menuItem'],
	setup(props) {
		const menuItemRef = toRef(props, 'menuItem');
		const classes = computed(() => {
			let classes = ['menu-item-container'];
			if (menuItemRef.value.selected) {
				classes.push('menu-item-container-selected');
			}
			return classes;
		});
		const menuItemIcon = computed(() => (menuItemRef.value.key in ICONS) ? ICONS[menuItemRef.value.key] : null);
		return {
			classes,
			menuItemRef,
			menuItemIcon,
			dark: Consts.COLORS.dark0,
			bgActive: Consts.COLORS.primary0,
		}
	},
}
</script>

<style scoped>
.menu-item-container {
	cursor: pointer;
	white-space: nowrap;
	margin: 0;
	padding: 0 20px;
	color: hsla(0, 0%, 100%, .65);
	background-color: transparent;
	transition: border-color .3s, background .3s;
	border-color: v-bind(dark);
}

.menu-item-container:hover,
.menu-item-container-selected {
	color: #fff;
	background-color: v-bind(bgActive);
}
</style>
